export const DATA_HIGHLIGHT_KEY = 'data-highlight-key';

export const TOKEN_CLASS = 'token';

export const HIGHLIGHT_Y_OFFSET = -100; // offset below highlight selection
